export const ADDRESS_BOOK_TYPES = {
  DELIVERY: "0",
  RETURN: "1",
};
